
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BreastSarcoma_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/BreastSarcoma_TNM.vue